import {
  headerAuth,
  normalizeTokenResponseScope,
  oauthAuth,
} from "../standardAuthPatterns";
import { defineProduct, productVariant } from "../types";
import { oauthSetupSteps } from "../oauthSetupSteps";
import logo from "./logo.svg";

const credential = productVariant({
  authLabel: "Personal API key",
  identifier: "linear",
  keywords: "issues tickets bugs projects cycles roadmap graphql",
  protocol: "http",
  defaultUrlPattern: () => "https://api\\.linear\\.app/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get a personal API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [Linear API settings](https://linear.app/settings/api) and create a new personal API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "Linear API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.linear.app/graphql",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "{ viewer { id } }" }),
    }),
  },
});

export const linear = defineProduct({
  name: "Linear",
  tagLine: "Issue tracking for teams",
  logo,
  tags: ["featured", "engineering", "productivity"],
  variants: [
    credential,
    productVariant({
      identifier: "linearOAuth",
      authLabel: "OAuth",
      protocol: "http",
      defaultUrlPattern: () => "https://api\\.linear\\.app/graphql(?:\\?.*)?$",
      auth: oauthAuth,
      steps: oauthSetupSteps({
        identifier: "linearOAuth",
        registrationUrl: "https://linear.app/settings/api",
        scopes: ["read"],
        instructions: "",
      }),
      oauth: {
        grantType: () => "authorization_code",
        authorizationEndpoint: () => "https://linear.app/oauth/authorize",
        tokenEndpoint: () => "https://api.linear.app/oauth/token",
        tokenEndpointAuthMethod: () => "client_secret_post",
        normalizeTokenResponse: normalizeTokenResponseScope,
        clientCredentialsFrom: "db",
        scopes: () => ["read"],
        pkce: () => true,
      },
      connectionTest: {
        protocol: "http",
        request: () => ({
          url: "https://api.linear.app/graphql",
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ query: "{ viewer { id } }" }),
          expectedBodyContains: ['"viewer"', '"id"'],
        }),
      },
    }),
  ],
});
